import { RoleData } from "types/models/master/MasterApp";
import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import RoleCreate from "./roleCreate";
import RoleHeader from "./roleHeader";


const defaultRole: RoleData = {
  id: 0,
  role: "",
  moduleType: "",
  isActive: 1,
};
const RoleIndex: React.FC = () => {
 

 
  return (
    <>
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <AppCard>
       
          <RoleHeader role={ defaultRole} />
            <AppGridContainer>
            <RoleCreate />
            </AppGridContainer>
        
      </AppCard>
    </AppAnimate>
    <AppInfoView />
  </>
  );
};

export default RoleIndex;
